import React,{ useCallback, useEffect } from 'react'
import { GoogleMap, useJsApiLoader, Marker, Circle, Autocomplete } from '@react-google-maps/api'
import usePlacesAutocomplete, { getGeocode, getLatLng } from 'use-places-autocomplete'
import { useState } from 'react'
import { MainInput, MainSelect, RegularText } from '../../helpers'
import LocationCityIcon from '@mui/icons-material/LocationCity';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { Box, Divider, List, ListItem, Paper } from '@mui/material'
import { customStyles } from '../../../styles'
import { useDispatch, useSelector } from 'react-redux'
import { loadMap } from '../../../slices/mapSlice'
import { useSplitAddress } from '../../../hooks/useSplitAddress'
import { fillAddressSlice } from '../../../slices'
import { autoFillAddress, resetForm } from '../../../slices/fillAddressSlice'
import { animations } from '../../../utils/animations'

const types = {
  noExt: 'street_number',
  address: 'route',
  colony: 'political',
  municipality: 'locality',
  state: 'administrative_area_level_1',
  country: 'country',
  postal_code: 'postal_code'
}

export const Map = ( {readOnly=false} ) => {
  const { editMode, accountSelected } = useSelector(state => state.accounts)
  const { latitude:lat, longitude:lng } = editMode && accountSelected[0]
  
  const { trackingOrder } = useSelector(state => state.order)
  const { isLoaded } = useSelector(state => state.map)
  const { street, extNumber, intNumber, postalCode, colony, latitude, longitude} = useSelector(state => state.fillAddress)

  // const { isLoaded } = useJsApiLoader({ 
  //   googleMapsApiKey: process.env.REACT_APP_MAPS_API_KEY,
  //   libraries: ["places"],
  // })
  
  // const { account } = trackingOrder && trackingOrder
  const dispatch = useDispatch()
  const options = usePlacesAutocomplete()
  
  const { ready, value, setValue, suggestions: {status, data}, clearSuggestions, clearCache } = usePlacesAutocomplete({
    requestOptions: {
      types: ['address'],
      componentRestrictions: { country: 'mx', },
      language: 'es'
    },
    //23.634501 y longitud -102.552784.
  })
  // const autocomplete = usePlacesAutocomplete()
  // const { restrictions:['mx'] } = new Autocomplete()
  
  const [searchAddress, setSearchAddress] = useState(value)
  const { sortData, newData } = useSplitAddress()
  const [selected, setSelected] = useState(null)
  const [addressValues, setAddressValues] = useState({})
  
  const handleCoors = () => {
    if(editMode){
      
      setZoom(18)
      setSelected({
        lat: lat,
        lng: lng
      })
    } else {
      readOnly
        ? setSelected({
          lat: trackingOrder?.account.latitude,
          lng: trackingOrder?.account.longitude
        })

        : navigator.geolocation.getCurrentPosition((position) => {
        setSelected({
              lat: position.coords.latitude,
              lng: position.coords.longitude
            })
          });
    }
  }
  useEffect(() => {
    setSearchAddress(value)
  }, [value])

  useEffect(() => {
    clearCache()
    handleCoors()
  }, [value, trackingOrder, readOnly])

    
  const [zoom, setZoom] = useState(10)
  

  // console.log(newAddress)

  
  const handleSelect = async (address) => {
    setValue(address, false)
    clearSuggestions()
    const results = await getGeocode( {address} )
    dispatch(autoFillAddress({ value: address }))
    sortData(results[0])
    const { lat, lng } =  getLatLng(results[0])
    setSelected({lat, lng})
    dispatch(autoFillAddress({latitude: lat, longitude: lng} ))
    setZoom(18)
  }
  
  const [pointer, setPointer] = useState(null)
  
  useEffect(() => {
    setPointer( 
      <Marker position={selected} animation="bounce"  title="Home" options/> 
      )
  }, [selected, ])

  const handleResetForm = () => {
    setValue('')
    dispatch(resetForm())
  }
  // const [activeInput, setActiveInput] = useState(false)
  const handleCleanInput = () => {
  }
  if(!isLoaded) return <h3>loading...</h3>
  
  return (
    <Box sx={{ position: 'relative' }}>
      {
        !readOnly &&
        <MainInput
        label={'Google Maps' } 
        icon={ !value ? <LocationCityIcon  /> : <ClearOutlinedIcon onClick={handleResetForm}/>}
        iconProps={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', cursor: 'pointer'  }} 
        columns={12}
        placeholder="Agrega tu dirección"
        sx={{marginBottom: 1}}
        value={searchAddress}
        onChange={(e) => setValue(e.target.value)}
        disabled={!ready}
        // onClick={handleCleanInput}   
        >
      
      <List sx={{
        border: `1px solid ${customStyles.colors.lightColor}`, borderRadius: 2,
        position: 'absolute', zIndex: 1, left: 0, width: '100%', backgroundColor: customStyles.colors.backgroundColor, padding: 0
      }}>
        {
          status==='OK' &&
          data.map(({ place_id, description }) => (
            <div key={place_id}>
            <ListItem onClick={() => handleSelect(description)} >
              <RegularText text={description}/>
            </ListItem>
            <Divider />
            </div>
          ))
        }
      </List>
    </MainInput>
    }
    <GoogleMap
      zoom={readOnly ? 18 : zoom}
      center={selected}
      mapContainerClassName="map_container"
    >
      { pointer }
      {/* <Marker position={selected} animation="bounce"  title="Home" options/>  */}
      {/* <Circle center={selected} radius={30}/> */}
    </GoogleMap>
      </Box>
  )
}
